<template>
  <b-container fluid>

    <b-modal ref="confirmModal"
             header-bg-variant="info"
             header-text-variant="light"
             ok-title="Μεταφορά"
             @ok="copyDepartments"
             cancel-title="Ακύρωση"
             title="Επιβεβαίωση Μεταφοράς Τμημάτων">
      <div class="d-block">
        <p style="font-size: 0.9em;">Η διαδικασία αυτή θα μεταφέρει τα τμήματα του έτους {{current - 1}}-{{current}} στο
          έτος
          {{current}}-{{current + 1}} μαζί με τις περσινές διαθεσιμότητες. Η μεταφορά θα γίνει μόνο για τμήματα που
          έχουν δηλώσει μαθήματα στο νέο έτος.</p>
        <p style="color: #9a4e5e;">Προσοχή η διαδικασία αυτή θα διαγράψει ότι αλλαγές έχετε κάνει (τμήματα
          και διαθεσιμότητες) και δεν είναι αναστρέψιμη.</p>
      </div>
    </b-modal>

    <div class="loading-parent">
      <loading :active.sync="isLoading"
               :is-full-page="fullPage"></loading>
    </div>

    <b-container style="padding-top: 0.5em;">
      <b-row>
        <b-col sm="6">
          <b-form-select size="sm" v-model="newInstitution" :options="institutionOptions">
            <template slot="first">
              <option value="null" disabled>-- Παρακαλώ επιλέξτε Ίδρυμα --</option>
            </template>
          </b-form-select>
        </b-col>

        <b-col sm="6">
          <b-form-select size="sm" v-model="newAcademic" :options="academicOptions">
            <template slot="first">
              <option value="null" disabled>-- Παρακαλώ επιλέξτε Τμήμα --</option>
            </template>
          </b-form-select>
        </b-col>
      </b-row>

      <b-button-group style="margin-top: 10px;">
        <b-button v-b-tooltip.hover="'Επιλέξτε Ίδρυμα και Τμήμα για Προσθήκη στη λίστα'" size="sm" variant="info"
                  @click="addRow">
          Προσθήκη
        </b-button>

        <b-button
          style="margin-left: 10px;"
          v-if="this.selected === this.current"
          variant="info"
          size="sm"
          title="Μεταφορά σε άλλο Έτος"
          @click="confirmCopyDepartments"
          v-b-popover.hover="this.tooltipString">
          Μεταφορά διαθεσιμότητας βιβλίων ανά τμήμα
        </b-button>
      </b-button-group>
      </b-container>
    <br/>

    <small>
      <b-table head-variant="light"
               small
               bordered
               hover
               ref="table"
               :items="tableMap"
               :fields="fields">
        <template slot="action" slot-scope="data">
          <b-button size="sm" v-b-tooltip.hover="'Αφαίρεση Τμήματος από τη λίστα'" variant="secondary"
                    @click="deleteRow(data)">Αφαίρεση
          </b-button>
        </template>
      </b-table>
    </small>
  </b-container>
</template>

<script>

  import requests, {GlobalEudoxusBus} from "../../js/DistributionRequestService";
  import Utils from "../../js/AppUtilities";
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.min.css';

  export default {
    name: "department-list-component",
    data() {
      return {
        isLoading: false,
        fullPage: true,
        selected: null,
        current: null,
        tooltipString: "",
        newInstitution: null,
        newAcademic: null,
        downloading: false,
        institutionOptions: [],
        academicOptions: [],
        objectMap: [],
        tableMap: [],
        fields: [
          {key: 'institution', label: 'Ίδρυμα', sortable: true, 'class': 'text-left'},
          {key: 'academic', label: 'Τμήμα', sortable: true, 'class': 'text-left'},
          {key: 'action', label: '', 'class': 'text-center'}
        ]
      }
    },
    components: {
      'loading': Loading
    },
    methods: {
      addRow() {
        this.isLoading = true;
        if (this.newInstitution != null && this.newAcademic != null) {
          let newInstitutionName, newAcademicName, newSecretariatId;

          for (let i = 0; i < this.institutionOptions.length; i++) {
            if (this.institutionOptions[i].value === this.newInstitution)
              newInstitutionName = this.institutionOptions[i].text;
          }

          for (let i = 0; i < this.academicOptions.length; i++) {
            if (this.academicOptions[i].value === this.newAcademic) {
              newAcademicName = this.academicOptions[i].text;
              newSecretariatId = this.academicOptions[i].secretariatId;
            }
          }
          requests.addSecretariatToDistributionPoint(requests.getDistributionPointId(), newSecretariatId, this.selected, this.reloadData);
        } else {
          this.isLoading = false;
          alert("Παρακαλω επιλέξτε Ίδρυμα και Τμήμα!");
        }
      },
      deleteRow(itemToDelete) {
        this.isLoading = true;
        requests.removeSecretariatFromDistributionPoint(requests.getDistributionPointId(), itemToDelete.item.secretariatId, this.selected, this.reloadData);
      },
      confirmCopyDepartments() {
        this.$refs.confirmModal.show();
      },
      copyDepartments() {
        this.isLoading = true;
        requests.copyDistributionPointSecretariats(requests.getDistributionPointId(), this.current - 1, this.current, this.reloadData);
      },
      reloadData(resultArray) {
          this.tableMap = Utils.departmentMapResolver(resultArray);
          this.$refs.table.refresh();
          this.isLoading = false;
      },
      setUpSelectors() {
        this.institutionOptions = [];
        this.academicOptions = [];

        this.institutionOptions.push({
          value: this.objectMap[0].institution[0].institutionId,
          text: this.objectMap[0].institution[0].institutionName
        });

        for (let i = 0; i < this.objectMap[0].academic.length; i++)
          this.academicOptions.push({
            value: this.objectMap[0].academic[i].academicId,
            text: this.objectMap[0].academic[i].academicName,
            secretariatId: this.objectMap[0].academic[i].secretariatId
          });
      }
    },
    created() {
      GlobalEudoxusBus.$on('departmentTableSetup', tableData => {
        if (tableData.length !== 0) {
          this.selected = tableData[0].selectedYear;
          this.current = tableData[0].currentYear;
          this.tableMap = [];
          this.tableMap = tableData[0].tableDeparts;
          this.tooltipString = "Μπορείτε να μεταφέρετε τα τμήματα και τις διαθεσιμότητες από το προηγούμενο έτος " + Number(this.current - 1) + "-" + this.current + " στο υπό διαμόρφωση " + this.current + "-" + Number(this.current + 1);
        }
      });
      GlobalEudoxusBus.$on('selectorsSetup', objectMap => {
        this.objectMap = objectMap;
        this.setUpSelectors();
      });
    }
  }
</script>

<style scoped>
  .loading-parent {
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/DepartmentsTabComponents/DepartmentListComponent.vue